import {WorkBook} from 'yougile-util'
import {SHEET_NAME} from '../constants'

export const getColumns = (workBook: WorkBook): string[] => {
  const sheet = workBook.Sheets[SHEET_NAME]
  const columns = new Set<string>()
  const cells = Object.keys(sheet)

  for (const cell of cells) {
    // XLSX store cells by rows,
    // firstly processed first row, then second
    if (!cell.match('[A-Z]+1$')) {
      break
    }
    columns.add(sheet[cell].v)
  }

  return [...columns]
}
